module.exports = __webpack_public_path__ + "img/glogo263.e8ea1693.png";